<template>
    <div>
        <v-dialog v-model="dialog_toggle_options" no-click-animation persistent scrollable fullscreen content-class="full-height" lazy transition="dialog-bottom-transition">
            <v-card>

                <v-toolbar flat>
				    <v-toolbar-side-icon @click="closeDialogWeb"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>

				    <v-toolbar-title class="white--text">{{ $root.appVersion < 117 ? 'Item Details' : 'Print Options'}}</v-toolbar-title>

				    <v-spacer></v-spacer>

                    <template v-if="!reorder && !rename">
                        <v-btn small round-borders outline @click="closeDialogWeb" v-if="$root.appVersion < 117">Done</v-btn>
				        <v-btn small round-borders outline @click="$parent.fn_savePrintOptions(otherFieldsPosition)" v-else>Done</v-btn>
                    </template>

                    <!-- <v-btn color="primary" flat small nopadding @click="reorder = !reorder">{{ !reorder ? 'Re-Order' : 'Done' }}</v-btn> -->
                    <v-btn small round-borders outline nopadding @click="fn_doneChanges" v-if="reorder || rename">Done</v-btn>
                    <!-- <v-menu>
                        <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                        <v-list nopadding>
                            <v-list-tile @click="reorder = !reorder">
                                <v-list-tile-title>{{reorder ? 'Cancel Reorder' : 'Reorder' }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="rename = !rename">
                                <v-list-tile-title>{{ rename ? 'Cancel Rename Columns' : 'Rename Columns' }}</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-menu> -->
                </v-toolbar>

                <v-card-text nopadding>
                    <v-alert type="info" icon="info_outline" :value="true" v-if="$root.appVersion < 117">
                        You can Enable/Disable item fields if added any
                    </v-alert>

                    <div class="switches" white-background v-if="$root.appVersion < 117">   
                        <v-switch class="mt-1" label="Note" v-model="$parent.description.showInPrintOut" nomargin @change="$parent.fn_toggleItemDetails('item_description', $event)"></v-switch>
                        
                        <v-switch class="mt-1" label="Item Description" v-model="$parent.itemDescription.showInPrintOut" nomargin @change="$parent.fn_toggleItemDetails('item_itemDescription', $event)"></v-switch>

                        <v-switch class="mt-1" label="Category" v-model="$parent.category.showInPrintOut" nomargin @change="$parent.fn_toggleItemDetails('item_category', $event)"></v-switch>

                        <v-switch class="mt-1" label="Brand" v-model="$parent.brand.showInPrintOut" nomargin @change="$parent.fn_toggleItemDetails('item_brand', $event)"></v-switch>

                        <v-switch class="mt-1" label="Company" v-model="$parent.company.showInPrintOut" nomargin @change="$parent.fn_toggleItemDetails('item_company', $event)"></v-switch>
                    </div>

                    <div class="switches" white-background v-else>

                        <v-list nopadding>

                            <template v-if="!reorder && !rename">
                                <v-subheader grey-back class="pr-0" v-if="groups.itemStaticFields.items.length">Item Fields <v-spacer></v-spacer> 
                                    <v-btn small flat capitalize color="primary" class="mr-0 pr-0" @click="reorder=true">re-order</v-btn>
                                    
                                    <v-menu>
                                        <v-btn slot="activator" icon><v-icon>more_vert</v-icon></v-btn>
                                        <v-list nopadding>
                                            <v-list-tile class="pr-0">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{$parent.fieldObj.itemsObj.itemDetailsAlignment.sectionName}}</v-list-tile-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action class="pl-3">
                                                    <v-switch style="padding: 0 !important;" nomargin v-model="$parent.fieldObj.itemsObj.itemDetailsAlignment.status"></v-switch>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </v-list>
                                    </v-menu>
                                </v-subheader>

                                <!-- <v-list-tile class="auto-height-tile" @click="fn_selectToRename($parent.fieldObj.itemsObj['tableColDescription'])">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ $parent.fieldObj.itemsObj['tableColDescription'].sectionName }}</v-list-tile-title>
                                        <v-list-tile-sub-title v-if="$parent.fieldObj.itemsObj['tableColDescription'].defaultSectionName != $parent.fieldObj.itemsObj['tableColDescription'].sectionName">({{ $parent.fieldObj.itemsObj['tableColDescription'].defaultSectionName ? $parent.fieldObj.itemsObj['tableColDescription'].defaultSectionName : $parent.fieldObj.itemsObj['tableColDescription'].sectionName }})</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                        <v-icon font16 class="mr-2">edit</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile> -->

                                <v-list-tile v-if="$parent.fieldObj && $parent.fieldObj.itemsObj && $parent.fieldObj.itemsObj.tableColSrNo" class="auto-height-tile mb-1" @click="fn_selectToRename($parent.fieldObj.itemsObj.tableColSrNo)">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ $parent.fieldObj.itemsObj.tableColSrNo.sectionName }} <span light-opacity-color>(Serial Number Column)</span></v-list-tile-title>
                                        <v-list-tile-sub-title v-if="$parent.fieldObj.itemsObj.tableColSrNo.defaultSectionName && $parent.fieldObj.itemsObj.tableColSrNo.defaultSectionName != $parent.fieldObj.itemsObj.tableColSrNo.sectionName">({{ $parent.fieldObj.itemsObj.tableColSrNo.defaultSectionName ? $parent.fieldObj.itemsObj.tableColSrNo.defaultSectionName : $parent.fieldObj.itemsObj.tableColSrNo.sectionName }})</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                        <v-icon font16 class="mr-2">edit</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <v-list-tile v-if="$parent.fieldObj && $parent.fieldObj.itemsObj && $parent.fieldObj.itemsObj.tableColDescription" class="auto-height-tile mb-1" @click="fn_selectToRename($parent.fieldObj.itemsObj.tableColDescription)">
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{ $parent.fieldObj.itemsObj.tableColDescription.sectionName }} <span light-opacity-color>(Item Details Column)</span></v-list-tile-title>
                                        <v-list-tile-sub-title v-if="$parent.fieldObj.itemsObj.tableColDescription.defaultSectionName && $parent.fieldObj.itemsObj.tableColDescription.defaultSectionName != $parent.fieldObj.itemsObj.tableColDescription.sectionName">({{ $parent.fieldObj.itemsObj.tableColDescription.defaultSectionName ? $parent.fieldObj.itemsObj.tableColDescription.defaultSectionName : $parent.fieldObj.itemsObj.tableColDescription.sectionName }})</v-list-tile-sub-title>
                                    </v-list-tile-content>

                                    <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                        <v-icon font16 class="mr-2">edit</v-icon>
                                    </v-list-tile-action>
                                </v-list-tile>

                                <template v-for="(item, index) in groups.itemStaticFields.items">
                                    <v-list-tile class="auto-height-tile mb-1" :key="'static_' + index" @click="fn_selectToRename(item)">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.sectionName }}</v-list-tile-title>
                                            <v-list-tile-sub-title v-if="item.defaultSectionName && item.defaultSectionName != item.sectionName">({{ item.defaultSectionName ? item.defaultSectionName : item.sectionName }})</v-list-tile-sub-title>
                                        </v-list-tile-content>

                                        <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                            <!-- <v-icon font16 class="mr-2" v-if="item.defaultSectionName == 'Description'">edit</v-icon> -->
                                            <v-switch v-if="item.sectionName != 'Item Name'" style="padding: 0 !important;" @change="$parent.fn_copyFieldObj(item)" v-model="item.status" nomargin></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>

                                <template v-if="groups.itemDynamicFields.items && groups.itemDynamicFields.items.length">
                                    <v-subheader grey-back>Item Custom Fields 
                                        <v-spacer></v-spacer> 
                                        <v-btn small flat color="primary" capitalize @click="otherFieldsPosition = 2" v-if="otherFieldsPosition == 1">Print as item details</v-btn>
                                        <v-btn small flat color="primary" capitalize @click="otherFieldsPosition = 1" v-else>Print as column</v-btn>
                                    </v-subheader>
                                    <template v-for="(item, index) in groups.itemDynamicFields.items">
                                        <v-list-tile class="auto-height-tile mb-1" :key="'dynamic_' + index">
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{ item.sectionName }}</v-list-tile-title>
                                                <!-- <v-list-tile-sub-title>{{ item.defaultSectionName ? item.defaultSectionName : item.sectionName }}</v-list-tile-sub-title> -->
                                            </v-list-tile-content>

                                            <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                                <v-switch style="padding: 0 !important;" @change="$parent.fn_copyFieldObj(item)" v-model="item.status" nomargin></v-switch>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                </template>
                                
                                <v-subheader grey-back>Other Fields</v-subheader>
                                <template v-for="(item, index) in groups.tableCols.items">
                                    <v-list-tile class="auto-height-tile mb-1" :key="'other_' + index">
                                        <v-list-tile-content @click="fn_selectToRename(item)">
                                            <v-list-tile-title>{{ item.sectionName }}</v-list-tile-title>
                                            <v-list-tile-sub-title v-if="item.defaultSectionName && item.defaultSectionName != item.sectionName">({{ item.defaultSectionName ? item.defaultSectionName : item.sectionName }})</v-list-tile-sub-title>
                                        </v-list-tile-content>

                                        <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                            <v-icon font16 v-if="item.tableColumn">edit</v-icon>
                                            <v-switch style="padding: 0 !important;" @change="$parent.fn_copyFieldObj(item)" v-model="item.status" nomargin></v-switch>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                            </template>

                            <template v-if="reorder && !rename">
                                <template v-for="(item, index) in groups.itemStaticFields.items">
                                    <v-list-tile class="auto-height-tile" :key="'static_reorder_' + index" @click="fn_selectToReorder(item)">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.sectionName }}</v-list-tile-title>
                                            <!-- <v-list-tile-sub-title v-if="item.defaultSectionName">{{ item.defaultSectionName ? item.defaultSectionName : item.sectionName }}</v-list-tile-sub-title> -->
                                        </v-list-tile-content>

                                        <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                            <v-icon color="primary">{{ selectedFieldItem && selectedFieldItem.fieldId == item.fieldId ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                            </template>

                            <!-- <template v-if="rename && !reorder">
                                <template v-for="(item, index) in groups.tableCols.items" v-if="item.tableColumn">
                                    <v-list-tile class="auto-height-tile" :key="'static_rename_' + index" @click="fn_selectToRename(item)">
                                        <v-list-tile-content>
                                            <v-list-tile-title>{{ item.sectionName }}</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ item.defaultSectionName ? item.defaultSectionName : item.sectionName }}</v-list-tile-sub-title>
                                        </v-list-tile-content>

                                        <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                            <v-icon color="primary">edit</v-icon>
                                        </v-list-tile-action>
                                    </v-list-tile>
                                </template>
                            </template> -->
                            
                           <!-- <v-subheader grey-back v-if="!rename">Item Fields</v-subheader>
                            <template v-for="(value, key) in $parent.fieldObj.itemsObj">
                                <div v-if="!rename" @click="fn_selectToReorder(value)">
                                    <template v-if="value.groupName == $parent.fieldObj.group && checkFieldAvailable(value)">
                                        
                                        <template v-if="!reorder">
                                            <v-divider v-if="!value.orderNumber"></v-divider>
                                            <v-list-tile class="auto-height-tile" :class="{'ml-3':value.orderNumber}">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ value.sectionName }}</v-list-tile-title>
                                                    <v-list-tile-sub-title>{{ value.defaultSectionName ? value.defaultSectionName : value.sectionName }}</v-list-tile-sub-title>
                                                </v-list-tile-content>

                                                <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                                    <v-switch style="padding: 0 !important;" @change="$parent.fn_copyFieldObj(value)" v-model="value.status" nomargin></v-switch>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </template>

                                        <template v-else>
                                            <v-list-tile class="auto-height-tile" v-if="value.orderNumber">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ value.sectionName }}</v-list-tile-title>
                                                    <v-list-tile-sub-title>{{ value.defaultSectionName ? value.defaultSectionName : value.sectionName }}</v-list-tile-sub-title>
                                                </v-list-tile-content>

                                                <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                                    <v-icon colo="primary">{{ selectedFieldItem && selectedFieldItem.fieldId == value.fieldId ? 'radio_button_checked' : 'radio_button_unchecked' }}</v-icon>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                        </template>
                                        
                                    </template>
                                    
                                </div>
                                
                                <div v-if="rename" @click="fn_selectToRename(value)">
                                    <template v-if="value.defaultSectionName">

                                        <v-list-tile class="auto-height-tile">
                                            <v-list-tile-content>
                                                <v-list-tile-title>{{ value.sectionName }}</v-list-tile-title>
                                                <v-list-tile-sub-title>{{ value.defaultSectionName ? value.defaultSectionName : value.sectionName }}</v-list-tile-sub-title>
                                            </v-list-tile-content>

                                            <v-list-tile-action style="display: flex;flex-direction: row;align-items: center;min-width: 80px;">
                                                <v-icon colo="primary" font16>edit</v-icon>
                                            </v-list-tile-action>
                                        </v-list-tile>
                                    </template>
                                    
                                </div>
                            </template> -->
                            
                        </v-list>
                    </div>

                    <div v-if="fn_isGstApplicable() && $parent.fieldObj && $parent.fieldObj.itemsObj && $parent.fieldObj.itemsObj['tableColGST'] && $parent.fieldObj.itemsObj['tableColGST'].status && !reorder">
                        <v-subheader grey-back>GST column options</v-subheader>
                        <div class="pl-3">
                            <v-radio-group row v-model="$parent.gstColumnType">
                                <v-radio class="mb-3" label="IGST/CGST/SGST/UTGST/CESS Percentage" :value="1"></v-radio>
                                <v-radio class="mb-3" label="IGST/CGST/SGST/UTGST/CESS Percentage + Amount" :value="2"></v-radio>
                                <v-radio class="mb-3" label="GST/CESS Percentage" :value="3"></v-radio>
                                <v-radio label="GST/CESS Percentage + Amount" :value="4"></v-radio>
                            </v-radio-group>
                        </div>
                    </div>

                    <div v-if="$parent.$refs['ref_previewTemplate'] && $parent.$refs['ref_previewTemplate'].isDiscounts && $parent.fieldObj && $parent.fieldObj.itemsObj && $parent.fieldObj.itemsObj['tableColDiscount'] && $parent.fieldObj.itemsObj['tableColDiscount'].status && !reorder">
                        <v-subheader grey-back>Discount column options</v-subheader>
                        <div class="pl-3">
                            <v-radio-group row v-model="$parent.fieldObj.itemsObj['tableColDiscount'].optionFlag">
                                <v-radio class="mb-3" label="Value & Percentage" :value="1"></v-radio>
                                <v-radio class="mb-3" label="Percentage Only" :value="2"></v-radio>
                                <v-radio class="mb-3" label="Value Only" :value="3"></v-radio>
                            </v-radio-group>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions v-if="reorder" full-width style="position: fixed;bottom: 0;">
                    <v-layout row wrap>
                        <v-flex xs6 sm6 md6 center-align style="border-right: 1px #ddd solid;">
                            <v-btn color="primary" flat @click="fn_moveField('up')" capitalize>move up <v-icon right color="primary">arrow_upward</v-icon></v-btn>
                        </v-flex>
                        <v-flex xs6 sm6 md6 center-align>
                            <v-btn color="primary" flat @click="fn_moveField('down')" capitalize>move down <v-icon right color="primary">arrow_downward</v-icon></v-btn>
                        </v-flex>
                    </v-layout>
                </v-card-actions>
            </v-card>   
        </v-dialog>
    </div>
</template>     

<script>

export default{
    data(){ 
        return{
            dialog_toggle_options:false,
            currentGstColumnType:null,
            reorder:false,
            rename:false,
            selectedFieldItem:null,
            // dynamicFieldLabel:'Print as item details',
            otherFieldsPosition:1,
            groups:{
                "itemStaticFields": {"items":[], "title":"Item Details"},
                "itemDynamicFields": {"items":[], "title":"Item Custom Fields"},
                "tableCols": {"items":[], "title":"Other"},
            }
        }
    },
    methods:{
        openDialogWeb: function () {
            this.dialog_toggle_options = true;
            this.selectedFieldItem = null;
            this.reorder = false;
            this.rename = false;

            this.$root.fn_getLocalItem('gstColumnType', response=>{
                let data = JSON.parse(response);
                if(data && data.LocalValue){
                    this.currentGstColumnType = Number(data.LocalValue);
                }
            });

            this.groups = {
                "itemStaticFields": {"items":[], "title":"Item Details"},
                "itemDynamicFields": {"items":[], "title":"Item Custom Fields"},
                "tableCols": {"items":[], "title":"Other"},
            }

            for (const [key, value] of Object.entries(this.$parent.fieldObj.itemsObj)) {
                if(value.itemField && this.$parent.$refs['ref_previewTemplate'].filteredItems && this.$parent.$refs['ref_previewTemplate'].filteredItems.length){
                    this.groups.itemStaticFields.items.push(value);
                }
                else if(value.itemCustomField){
                    this.groups.itemDynamicFields.items.push(value);
                }
                else if(value.groupName == this.$parent.fieldObj.group && this.checkFieldAvailable(value)){
                    if(value.fieldId == 'tableColDiscount' && !this.$parent.$refs['ref_previewTemplate'].isDiscounts){
                        continue;
                    }
                    else{
                        this.groups.tableCols.items.push(value);
                    }
                }
            }

            // sorting static fields as per order number
            this.groups.itemStaticFields.items.sort(function(a, b){
                return a.orderNumber - b.orderNumber;
            });
            // end of sorting fields

            // removing gst column in case of unregister or composite
            if(this.$root.CurrentBusiness.GSTRegistrationStatus != 1){
                let gstItemIndex = this.groups.tableCols.items.findIndex(col=>{
                    return col.sectionName == 'GST';
                })

                if(gstItemIndex != -1){
                    this.groups.tableCols.items.splice(gstItemIndex, 1);
                }
            }
            // end of removing gst column

            if(this.$parent.$refs['ref_previewTemplate'].otherFieldsPosition){
                this.otherFieldsPosition = this.$parent.$refs['ref_previewTemplate'].otherFieldsPosValue;
            }
            // this.fn_sortByOrder();
        },

        fn_sortByOrder: function(){
            // Step 1: Convert object to array, sort by orderNumber
            const sortedEntries = Object.entries(this.$parent.fieldObj.itemsObj)
            .sort(([, a], [, b]) => a.orderNumber - b.orderNumber);

            // Step 2: Convert back to object
            this.$parent.fieldObj.itemsObj = Object.fromEntries(sortedEntries);
        },

        closeDialogWeb: function () {
            if(this.reorder){
                this.reorder = false;
            }
            else{
                this.dialog_toggle_options = false;
            }
        },

        checkFieldAvailable: function(value){
            let itemIndex = this.$parent.data.transactionDetails.otherDetails.transactionFields.findIndex(field=>field.fieldId === value.fieldId);
            if((itemIndex!=-1 || value.groupName == 'InvoiceTable') && value.fieldId != 'tableColTaxableValue'){
                return true;
            }
            else{
                return false;
            }
        },

        fn_selectToReorder: function(field){
            if(this.reorder){
                this.rename = false;
                // for(let key in this.batchFields){
                // 	this.batchFields[key].selected = false;
                // }
                // this.$parent.fieldObj.itemsObj.forEach(item => {
                //     item.selected = false;
                // });
                this.selectedFieldItem = field;
            }
        },

        fn_selectToRename: function(obj){
            if(obj.defaultSectionName){
                this.reorder = false;
                this.selectedFieldItem = obj;
                this.$parent.fn_openDialogTextContent();
            }
        },
        
        fn_moveField: function(type){
            let itemIndex = this.groups.itemStaticFields.items.findIndex(item=>{return item.fieldId == this.selectedFieldItem.fieldId});
            let tempItem = this.groups.itemStaticFields.items[itemIndex];
            this.groups.itemStaticFields.items.splice(itemIndex, 1);
            let insertIndex = type == 'up' ? itemIndex - 1 : itemIndex + 1;
            this.groups.itemStaticFields.items.splice(insertIndex, 0, tempItem);
            for(let i=0; i<this.groups.itemStaticFields.items.length; i++){
                this.groups.itemStaticFields.items[i].orderNumber = (i + 1);
            }
        },

        // fn_moveUp: function(){
        //     if(!this.selectedFieldItem){
        //         this.showToast("Select Item");
        //         return
        //     }

        //     const current = this.$parent.fieldObj.itemsObj[this.selectedFieldItem.fieldId];
        //     if (!current) return;

        //     const targetOrder = current.orderNumber - 1;
        //     if (targetOrder < 1) return; // Already at top

        //     for (const [key, value] of Object.entries(this.$parent.fieldObj.itemsObj)) {
        //         if (value.orderNumber === targetOrder) {
        //             value.orderNumber += 1;
        //             current.orderNumber -= 1;
        //             break;
        //         }
        //     }

        //     this.$parent.fn_copyFieldObj(current);
        //     this.fn_sortByOrder();
        // },

        // fn_moveDown: function(data){
        //     if(!this.selectedFieldItem){
        //         this.showToast("Select Item");
        //         return
        //     }

        //     const current = this.$parent.fieldObj.itemsObj[this.selectedFieldItem.fieldId];
        //     if (!current) return;

        //     const targetOrder = current.orderNumber + 1;
        //     const maxOrder = Math.max(...Object.values(data).map(d => d.orderNumber));
        //     if (targetOrder > maxOrder) return; // Already at bottom

        //     for (const [key, value] of Object.entries(this.$parent.fieldObj.itemsObj)) {
        //         if (value.orderNumber === targetOrder) {
        //             value.orderNumber -= 1;
        //             current.orderNumber += 1;
        //             break;
        //         }
        //     }

        //     this.$parent.fn_copyFieldObj(current);
        //     this.fn_sortByOrder();
        // },

        fn_doneChanges: function(){
            if(this.reorder){
                this.reorder = false;
                return;
            }

            this.reorder = false;
            this.rename = false;
            this.$parent.fn_savePrintOptions(this.otherFieldsPosition);
        },

        fn_isGstApplicable: function(){
            if(this.$root.CurrentBusiness.GSTRegistrationStatus == 1)
                return true;
            else{
                if(this.$parent.data.transactionDetails.transactionListId == 20001 || this.$parent.data.transactionDetails.transactionListId == 20002 || this.$parent.data.transactionDetails.transactionListId == 20003 || this.$parent.data.transactionDetails.transactionListId == 20004)
                    return true;
                else
                    return false;
            }
        }

        // fn_changeDynamicItemFieldPosition: function(){

        //     let value = null
        //     for(let i=0; i<this.groups.itemDynamicFields.items.length; i++){
        //         this.groups.itemDynamicFields.items[i].positionTableColumn = !this.groups.itemDynamicFields.items[i].positionTableColumn;
        //         value = this.groups.itemDynamicFields.items[i].positionTableColumn;
        //     }

        //     if(value){
        //         this.dynamicFieldLabel = 'Print as item details';
        //     }
        //     else {
        //         this.dynamicFieldLabel = 'Print as column';
        //     }
        // }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/invoice_templates/dialogs/dialog_toggle_options.vue